import { ErrorMessageComponent } from './ErrorMessage';

export const DefaultErrorMessage: ErrorMessageComponent = (props) => {
  const { error, errorMessage = error } = props;

  return <>{errorMessage}</>;
};
